<template>
    <div class="edit">
        <div class="popup">
            <div class="title">
                修改{{editObj.name}}
                <i class="el-icon-close" @click="$emit('close')"></i>
            </div>
            <div class="con">
                <span>{{editObj.name}}</span>
                <el-input v-model="value" ></el-input>
                <span>{{editObj.unit}}</span>
            </div>
            <div class="foot">
                <el-button @click="$emit('close')">取消</el-button>
                <el-button type="primary" @click="$emit('close', {name:editObj.name, value})">确定</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:['editObj'],
    data(){
        return {
            value:null
        }
    },
    mounted(){
        if(this.editObj){
            this.value = this.editObj.num
        }
    },
    methods:{

    }

}
</script>

<style lang="less" scoped>
    .edit{
        width: 100vw;
        height: 100vh;
        position: fixed;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.24);
        z-index: 999;
        

        .popup{
            width: 596px;
            height: 324px;
            background: #FFFFFF;
            box-shadow: 0px 0px 68px 0px rgba(19,28,36,0.24);
            border-radius: 12px;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            .title{
                height:6vh ;
                line-height: 6vh;
                padding-left: 19px;
                font-size: 24rem;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: #333333;
                border-bottom:1px solid  #E5E5E5;
                position: relative;
                &>i{
                    position: absolute;
                    right: 1vw;
                    top: 50%;
                    transform: translate(-50%, -30%);
                    font-weight: bold;
                    cursor: pointer;
                }
            }
            .con{
                height:167px ;
                display: flex;
                justify-content: center;
                align-items: center;
                &>span:nth-child(1){
                    font-size: 18rem;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: #333333;
                    height: 4.8vh;
                    line-height: 4.8vh;
                }
                &>span:nth-child(3){
                    font-size: 24rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #333333;
                    height: 4.8vh;
                    line-height: 4.8vh;
                }
                /deep/ .el-input{
                    width: 4vw;
                    height: 4.8vh;
                    margin: 0 0.5vw;
                    
                    .el-input__inner{
                        text-align: center;
                        font-size: 24rem;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        color: #333333;
                    }
                }
            }

            .foot{
                display: flex;
                justify-content: space-evenly;
                &>button{
                    width: 168px;
                    height: 56px;
                    font-size: 18rem;
                }
            }
        }

        
    }
</style>